/**
 * accueil-evenement.js
 */

// Import
import "./accueil-evenement.scss";
import "../../assets/script/isotope_init.js";
import $ from 'jquery';

$(document).ready(function() {

    const dateArray = [];
    const dateOrdreObject = {};
    $('.un-evenement .jour').each(function(){
        dateArray.push($(this).data('date')+' '+$(this).next().text());
        dateOrdreObject[$(this).attr('id')] = 0;
    });

    for(var i=0; i<dateArray.length; i++) {
        for(var j=0; j<dateArray.length; j++){
            if(dateArray[i] > dateArray[j]){
                dateOrdreObject['date-'+i]++
            }
        }
    }

    Object.keys(dateOrdreObject).forEach(key => {
        /*$('#'+key).parent().addClass('order-'+dateOrdreObject[key]);*/
    });

    // Réajustement de l'ordre des événements selon le timestamp

    var $grid = $('.grid').isotope({
        itemSelector: '.grid-item',
        layoutMode: 'fitRows',
        getSortData: {
            date: '[data-date-unix]'
        },
    });

    $grid.isotope({ sortBy: ['date'] });

});



